<form [formGroup]="form" *ngIf="field">
  <div class="form-field check-field">
    <span class="checkbox-icon">
      <input type="checkbox" formControlName="show" id="showTitle" />
      <label class="inline-icon icon-editor-checkbox-light-unchecked" for="showTitle"> {{ titleCheckboxLabel }} </label>
    </span>
  </div>
  <label class="label-form-control">
    {{ titleInputLabel }}
    <input
      class="form-control form-control-sm text-form-control"
      type="text"
      formControlName="text"
      [placeholder]="field.defaultTitle || field.baseFormatDisplayName || field.displayName"
      (keydown.enter)="$event.target.blur()"
    />
  </label>
</form>
